userVars = setUserVars({});

function setUserVars(obj) {
    return new Proxy(obj, {
        get(target, property) {
            if (property in target) {
                return target[property];
            }

            if (property in window.trialData?.stimLists) {
                // return flat array of all stim values
                return window.dynamicLists.getStaticListValues(property); // Import the property
            }
            
            return target[property];
        }
    });
}

window.dynamicLists.initFunctions();

/*reserved vars: 
    response 
    RT 
    correct
*/

window.userScriptEvents = {
    start: 'start',
    end: 'end'
};

function initializeUserScripts(trialRow) {
    var userScript = window.columnForTrial('script', trialRow);
    userScript = escapeScript(userScript);
    userScript = replaceScriptVariablesInFunctions(userScript);
    userScript = replaceScriptVariables(userScript);
    var scriptObject = getScriptStages(userScript);

    return scriptObject;
}

function escapeScript(script) {
    script = script.replace(/‘|’|'/g, "\'");
    script = script.replace(/“|”|"/g, "\"");
    script = script.replace(/\t/g, "\\t");
    script = script.replace(/\\/g, "\\");

    return script;
}

function replaceScriptVariablesInFunctions(script) {
    const regex = /(?<scriptFunction>addToList)\((?<arguments>.+)\)/gm;

    let matches, newScript = script;
    while(matches = regex.exec(script)) {
        let arguments = matches.groups.arguments, newArguments;
        newArguments = replaceScriptVariables(arguments, addScopeToUserVar = false);
        newScript = newScript.replace(arguments, newArguments);
    }

    return newScript;
}

function replaceScriptVariables(script, addScopeToUserVar = true) {
    const userVarsScope = 'userVars';
    const reservedVars = ['response', 'RT', 'correct'];

    /*
        Group 0 will be full match
        Group 1 will hold the varName,
        Group 2 will hold the index for testable vars
    */
    const variableRegex = "(?<varType>response|RT|correct|\\w+)(-?\\d+)?";
    const functionRegex = "(\\.(?<varFunction>random|sample))?";

    const finalRegex = new RegExp('%' +
        variableRegex +
        functionRegex +
        '%', 'gmi'
    );
    var newScript = script;
    var matches;

    while(matches = finalRegex.exec(script)){
        var varName = matches.groups?.varType;
        if(reservedVars.includes(varName)){
            newScript = replaceTestableVariable(newScript, matches);
        }
        else{
            if(addScopeToUserVar) {
                newScript = newScript.replace(matches[0], userVarsScope + '.' + varName);
            } else {
                newScript = newScript.replace(matches[0], '"' + varName + '"');
            }
        }
    }

    return newScript;
}

//function used in script column to add a variable to a list
function addToList(userList, variable) {
    if(!variable) {
        return;
    }

    // if the list doesn't exist in userVars with bring it from stimLists
    if (!Array.isArray(userVars[userList])) {
        const staticListValues = window.dynamicLists.getStaticListValues(userList) || [];
        userVars[userList] = staticListValues;
    }

    if (typeof variable === "string") {
        variable = variable.split(';')
    } 

    userVars[userList] = userVars[userList].concat(variable);
}

function replaceTestableVariable(script, regexMatch) {
    /* regexMatch:
        Group 0 will be full match
        Group 1 will hold the varName,
        optional: Group 2 will hold the index for testable vars
    */

    const testableArrays = {
        response: {
            relative: "window.allResponses",
            absolute: "window.rowResponses",
        },
        RT:{
            relative: "window.allRTs",
            absolute: "window.rowRTs",
        },
        correct:{
            relative: "window.allCorrects",
            absolute: "window.rowCorrects",
        },
    };

    var varName = regexMatch[1];
    var index = parseInt(regexMatch[2]) || 0;
    var replacementString = "";

    if (index <= 0) {
        var replacementArray = testableArrays[varName]["relative"];
        replacementString = replacementArray + "[" + replacementArray + ".length - 1 + " + index + "]";
    }
    else {
        var replacementArray = testableArrays[varName]["absolute"];
        replacementString = replacementArray + "[" + (index - 2) + "]";
    }
    
    return script.replace(regexMatch[0], replacementString);
}


function getScriptStages(script) {
    if(script === "na"){
        return {};
    }

    var scriptObject = {};
    var stages = script.split(/^end:/m);
    // scriptObject.start = stages[0];
    scriptObject.start = createFunction(stages[0]);
    if(stages.length > 1) {
        // scriptObject.end = stages[1];
        scriptObject.end = createFunction(stages[1]);
    }

    return scriptObject;

    function createFunction(script) {
        var f;
        try {
            f = new Function(script); 
        } catch (error) {
            alert("Error: " + error.message + ':\n { ' + script + ' }');
            throw error.message + ': {' + script + '}';
        }
        return f;
    }
}

function runUserScript(trialRow, event) {
    fn = window.listTrialScripts[trialRow][event];
    if (fn && (fn instanceof Function)) {
        fn();
	}
}

function getTalliesString() {
    var talliesString = "";
    for(var key in window.userVars){
        talliesString = talliesString + key + ' : ' + window.userVars[key] + '; ';
    }

    return talliesString;
}

function saveTallies() {
    window.runUserScript(window.trialRow, window.userScriptEvents['end']);
    const talliesString = getTalliesString();
    window.tallies.push(talliesString);
}

function skipTrial() {
    if(window.theEndCalled || trial==noTrialsGroup-1) {
        return;
    }
    //hideAll();
    window.main();
}